import api from '@/services/api';
import { resolveApiUrl } from '@/shared/utils/resolve_api_url.js';
import { useLoading } from '@/shared/composables/loading.js';
import { ElNotification } from 'element-plus';

export function usePrint() {
  const getDataReportByName = async (reportName, filters) => {
    try {
      const result = await api.post(`/reportes/${reportName}`, filters, { timeout: 2 * 60 * 1000 }); // Timeout de 1 minuto
      if (result && result.data && result.data.success) {
        return { success: true, data: result.data };
      }
    } catch (error) {
      console.error('Error en generateReports:', error);

      const mensajeBackend = error.response?.data?.mensaje || 'Error generando el informe.';
      return { success: false, data: { mensaje: mensajeBackend } };
    }
  };

  const printReport = async (reportName, filters) => {
    try {
      useLoading().openLoading('Generando PDF...');

      const result = await getDataReportByName(reportName, filters);

      if (result && result.success && result.data.success) {
        const reportURL = resolveApiUrl(result.data.url);
        window.open(reportURL, '_blank');
        ElNotification({
          title: 'Éxito',
          message: 'Informe generado exitosamente',
          type: 'success',
        });
      } else {
        const mensajeError =
          result?.data?.mensaje || result?.mensaje || 'Hubo un problema al generar el informe.';
        const esErrorSistema =
          mensajeError.toLowerCase().includes('error al generar') ||
          mensajeError.toLowerCase().includes('problema al generar');

        ElNotification({
          title: esErrorSistema ? 'Error' : 'Advertencia',
          message: mensajeError,
          type: esErrorSistema ? 'error' : 'warning',
          duration: esErrorSistema ? 4500 : 6000,
        });
      }
    } catch (error) {
      ElNotification({
        title: 'Error',
        message: error.message || 'Hubo un problema al procesar la solicitud.',
        type: 'error',
      });
    } finally {
      useLoading().closeLoading();
    }
  };

  return {
    printReport,
    getDataReportByName,
  };
}
